import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { ChangeLocationActivityPayload } from "../../payload/ChangeLocationActivity/ChangeLocationActivityPayload";

const changeLocationActivityFetch = (state: LocationsState, action: PayloadAction<ChangeLocationActivityPayload>) => {
    state.isLoading = true;
}

export default changeLocationActivityFetch;